import React from 'react';
import { Box, Text, VStack, Heading, Icon, Flex } from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';
import { useQuery } from 'react-query';
import { Api } from 'api';
import { Trans } from '@lingui/macro';

interface MasterNotesBannerProps {
  brandId?: number;
  modelId?: number;
  modelYear?: number;
  noteType: number;
}

export const MasterNotesBanner: React.FC<MasterNotesBannerProps> = ({ brandId, modelId, modelYear, noteType }) => {
  const { data: notes } = useQuery(
    ['GetActiveMasterNotes', brandId, modelId, modelYear, noteType],
    async () => {
      if (!brandId || !modelId) return [];
      const response = await Api.Expertise.getActiveMasterNotes(brandId, modelId, modelYear, noteType);
      return response.data;
    },
    {
      enabled: !!brandId && !!modelId,
      refetchOnWindowFocus: false,
    },
  );

  if (!notes || notes.length === 0) {
    return null;
  }

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      p={4}
      mb={4}
      bg="orange.50"
      borderColor="orange.200"
      color="orange.800"
      width="100%"
      boxShadow="sm"
    >
      <Flex align="center" mb={2}>
        <Icon as={InfoIcon} mr={2} color="orange.500" w={5} h={5} />
        <Heading size="xs" textTransform="uppercase" letterSpacing="wider">
          <Trans>Ustadan Ustaya Araç Notları</Trans>
        </Heading>
      </Flex>
      <Box maxH="120px" overflowY="auto" pr={2}>
        <VStack align="stretch" spacing={2}>
          {notes.map((item) => (
            <Box
              key={item.id}
              p={2}
              bg="white"
              borderRadius="md"
              borderLeftWidth="4px"
              borderLeftColor="orange.400"
              boxShadow="2xs"
            >
              <Text fontSize="sm" fontWeight="medium" whiteSpace="pre-wrap" wordBreak="break-word">
                {item.note}
              </Text>
            </Box>
          ))}
        </VStack>
      </Box>
    </Box>
  );
};
